/**
 *  Returns a deep copy of any value.
 *  For example, if given an object which contains an array, the return will be a new object containing a new array.
 *  @param value anything that needs to be deep copied
 *  @returns a deep copy of the original value
 **/
export const deepClone = (value: any): any => {
    let clone: any;
    if (value instanceof Array) {
        clone = [];
        for (const arrayObj of value) {
            clone.push(deepClone(arrayObj));
        }
    } else if (value instanceof Object) {
        clone = {};
        for (let prop in value) {
            clone[prop] = deepClone(value[prop]);
        }
    } else {
        clone = value;
    }

    return clone;
};
